import { useTranslation } from 'react-i18next';
import { supportedLanguages, type SupportedLanguage } from '@/i18n';

/**
 * Returns a function that prefixes a path with the current locale.
 * Usage: const lp = useLocalePath(); <Link to={lp('/library')} />
 */
export const useLocalePath = () => {
  const { i18n } = useTranslation();
  const lang = supportedLanguages.includes(i18n.language as SupportedLanguage)
    ? i18n.language
    : 'en';

  return (path: string) => {
    // Don't prefix external URLs, hash-only links, or admin routes
    if (path.startsWith('http') || path.startsWith('mailto:') || path.startsWith('/admin')) {
      return path;
    }
    
    // Handle hash links on homepage: /#section -> /en/#section
    if (path.startsWith('/#')) {
      return `/${lang}${path}`;
    }
    
    // Handle pure hash links
    if (path.startsWith('#')) {
      return path;
    }
    
    // Handle paths: /library -> /en/library
    if (path.startsWith('/')) {
      return `/${lang}${path}`;
    }
    
    return `/${lang}/${path}`;
  };
};
